export default "__VITE_ASSET__59469282__"